import { getFunctions, httpsCallable } from "firebase/functions";
import React, { useState, useEffect } from "react";
import { Grid, Checkbox, Label, Input, Box, Flex, Button, Text } from 'theme-ui';
import { useFirebaseProfile } from './useFirebaseProfile';

const REQUIRED = [
  'Educational',
  'Sponsorship/Alumni',
  'Social',
  'Meet the Board',
];

const EXAMPLES = [
  'examples include... Intro to Tech Interviews, Intro to Networking',
  'examples include... Leetcode and Levain, Google x WiCS',
  'examples include... Phone Charms with WiCS, WiCS x HSBSE Mixer',
  'look out for emails about regular MTB opportunities!',
];

const Comp = () => {

  const [userProgress, setUserProgress] = useState({
    completedEvents: [],
    count: 0,
    total: 0,
  });

  const { profile } = useFirebaseProfile();
  
  const firstName = profile.displayName 
    ? profile.displayName.split(' ')[0]
    : 'WiCS';

  useEffect(() => {

    // okay what i want to do:
    // 1. call the sheet
    // 2. read email column
    // 3. read row and find event
    // 4. repeat until end of form or all four event types have been found
    // 5. display relevant
    // official kinds: Educational, Sponsorship/Alumni, Social, Meet the Board; 6 in total

    // LOGIC IS ALL IN FUNCTIONS

    const load = async () => {
      const functions = getFunctions();
      const getSheetData = httpsCallable(functions, "getSheetData");
      const res = await getSheetData();

      setUserProgress({
        total: res.data.totalEvents,
        completedEvents: res.data.completedKinds,
        isComplete: res.data.isComplete,
      });

    };

    load();
  }, []);

  return (
    <div style={{ width: '100%', height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', color: '#F9F9F9', justifyContent: 'center', paddingTop: '5%', }}>
      
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', }}>

        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', }}>

          <img src={'2nd-icon.png'} />
          <Text sx={{ 
            fontSize: 4, 
            fontWeight: 'bold', 
            mb: 3, 
            color: 'white', 
            backgroundColor: '#6E4884', 
            padding: '15px 30px', 
            borderRadius: '20px', 
            }}>{firstName}'s Comp Progress</Text>
            <img src={'2nd-icon.png'} />

        </div>

        <Text sx={{ fontSize: '20px', 
          fontWeight: 'bold', 
          mb: 3, 
          color: '#6E4884', 
          padding: '20px',
          }}> you have completed {userProgress.total} out of 6 total events!</Text>

        <Text sx={{ fontSize: 2, 
          mb: 3, 
          listStyleType: 'none', }}>
          {REQUIRED.map(kind => (

            <div style = {{ 
                display: 'flex',
                marginBottom: '10px', 
                backgroundColor: '#D5B3E7', 
                padding: '10px 20px',
                borderRadius: '20px', 
                width: '100%',
                }}>
                  
              <input type="checkbox" 
              key={kind} 
              checked={userProgress.completedEvents.includes(kind)} 
              readOnly 
              id={kind} />
              <label for={kind} style={{ color: '#6E4884', fontWeight: 'bold', paddingLeft: '10px' }}>{kind}</label>
              
              <Text sx={{ 
                fontStyle: 'italic',
                color: 'white',
                marginLeft: 'auto',
                textAlign: 'right',
                paddingLeft: '35px'
              }}>{EXAMPLES[REQUIRED.indexOf(kind)]}</Text>
            </div>
          ))}
        </Text>

        <Text sx={{
          color: 'grey',
          fontSize: 2,
          fontWeight: 'bold',

        }}>
          click <a href="/Events" style={{ textDecoration: 'underline', }}>here</a> to see upcoming events!
        </Text>
      </div>

      
        <div style={{ height: '100%', }}>
          {userProgress.isComplete && (
            <div style={{ display: 'flex', height: '100%', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', }}>
              <img src={'3rd-icon.png'} style={{ height: '20%', transform: 'scaleX(-1)' }} />
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Text sx={{ fontWeight: 'bold', color: '#6E4884', fontSize: '33px', padding: '10px' }}>congratulations! you have completed your comp!</Text>
                <Text sx={{ fontWeight: 'bold', color: '#6E4884', fontSize: '33px', marginBottom: '50px' }}>welcome to the WiCS community :)</Text>
              </div>
              <img src={'3rd-icon.png'} style={{ height: '20%'}} />
            </div>
          )}
        </div>
      

    </div>

    // include link to events page

  );


};

export default Comp;